module.exports = __webpack_public_path__ + "img/scene-of-sound-logo.340dddbf.png";